package com.parmartechnologies.core.navigation

import com.parmartechnologies.core.app.navigation.AppNavigator
import kotlinx.coroutines.launch

class BaseNavigator {
    private var openLink: ((String) -> Unit)? = null
    var params : MutableMap<String, NavigationParam?> = mutableMapOf()
    var onBackPress : ()-> Unit = {}
    var getNavParams : NavigationParam
        get() {
            return NavigationParam()
        }
        set(value) {

        }
    init {
        instance = this
    }

    companion object {
        private var instance: BaseNavigator? = null
        fun shared(): BaseNavigator {
            return if (instance != null) {
                instance as BaseNavigator
            } else {
                instance = BaseNavigator()
                instance as BaseNavigator
            }
        }
    }

}